<template>
    <div class="qa-setting-component">
        <el-dialog :title="$t('component.QaSetting_title')" :visible.sync="show" destroy-on-close width="860px" top="20px">
            <div style="width:90%;margin:auto;">
                <div class="text-center fonts-14 padding-b-20 color-warning" v-if="view === 'preview'">{{ $t('component.QaSetting_tips_2') }}</div>
                <div class="block-title">{{ $t('component.QaSetting_type_title_1') }}</div>
                <div class="option-list">
                    <template v-for="(item,index) in basicList">
                        <div class="item" :key="index"> <!-- :disabled="!item.enabled" -->
                            <el-checkbox v-model="item.selected" :disabled="view === 'preview' || !item.enabled" :label="item.description"></el-checkbox>
                        </div>
                    </template>
                </div>
                <div class="block-title">{{ $t('component.QaSetting_type_title_2') }}</div>
                <div class="option-list">
                    <template v-for="(item,index) in aiList">
                        <div class="item" :key="index">
                            <el-checkbox v-model="item.selected" :disabled="view === 'preview' || !item.enabled" :label="item.description"></el-checkbox>
                        </div>
                    </template>
                </div>
                <template v-if="userInfo.organizationType === 'ENTERPRISE'">
                    <div class="block-title">{{$t('component.QaSetting_type_title_3')}}</div>
                    <div class="option-list">
                        <div class="item">
                            <el-checkbox v-model="checkQa" :disabled="view === 'preview'" :label="$t('component.QaSetting_tips_1')"></el-checkbox>
                        </div>
                    </div>
                </template>
                <!-- <div style="font-size:12px;">
                    <svg-icon name="ib-warning" style="width: 14px;height: 14px;fill:#FDB500;"></svg-icon> {{ $t('component.QaSetting_fluency_tips') }}
                </div> -->
            </div>
            <div slot="footer" style="text-align: center;" v-if="view !== 'preview'">
                <el-button plain round size="small" @click="show = false">{{ $t('component.QaSetting_button_cancel') }}</el-button>
                <el-button round type="primary" size="small" :loading="loading" @click="submitBtnEvent">{{ $t('component.QaSetting_button_submit') }}</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { qaApi, projectApi } from '@/utils/api';
export default {
    props: {
      
        doc:{
            type: Object,
            default: null
        },
        view: {
            type: String,
            default: 'setting', // 'preview'
        }
    },
    data(){
        return{
            show:false,
            loading:false,
            basicList:[],
            aiList:[],
            checkQa: false,
        }
    },
    computed: {
		...mapState({
			userInfo: state => state.user.userData,
		}),
	},
    methods:{
        initList(){
            let url = `${qaApi.queryQaConfig}?projectId=${this.doc.projectId}`;
            this.$ajax.get(url).then(res=>{
                if(res.status === 200){
                    this.checkQa = res.data.checkQa;
                    let list = res.data.options;
                    list.map(item=>{
                        if(item.type === 'BASIC'){
                            this.basicList.push(item);
                        }else if(item.type === 'AI'){
                            this.aiList.push(item);
                        }
                    });
                }
            })
        },
        setShow(){
            this.show = true;
        },
        submitBtnEvent(){
            let list = [].concat(this.basicList, this.aiList);
            this.loading = true;
            let url = this.$ajax.format(projectApi.updateProjectsSettingInfo,{id: this.doc.projectId})

            let optionsObject = {};
            list.forEach(option => {
                optionsObject[option.code] = option.selected;
            });

            this.$ajax.put(url,{qaSetting:{selected: optionsObject, checkQa: this.checkQa}}).then(res=>{
                if(res.status === 200){
                    this.$message.success(this.$t('component.QaSetting_success_message'));
                    this.show = false;
                    if(this.$listeners['submit']){
                        this.$emit('submit');
                    }
                }
            }).finally(()=>{
                this.loading = false;
            })
        }
    },
    mounted(){
        this.initList();
    }
}
</script>
<style lang="scss" scoped>
.qa-setting-component{
    .block-title{
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 10px;
    }
    .option-list{
        display: flex;
        margin-bottom: 25px;
        flex-wrap: wrap;
        .item{
            width: 25%;
            padding: 10px 0;
            word-break: break-all;
            word-wrap: break-word;
        }
    }
}
</style>
